import { Node, mergeAttributes } from '@tiptap/core';

// ролик в тексте материала: плеер VK Видео или RuTube в iframe.
// Положение хранится классом, ширина стилем — их пропускает бэкенд
// (app/article_content.py), остальные атрибуты он вырезает.
export const VIDEO_CLASS = 'article-video';
export const VIDEO_PAGE_CLASS = `${VIDEO_CLASS}_page`;

export const ArticleVideo = Node.create({
    name: 'articleVideo',
    group: 'block',
    atom: true,
    draggable: true,

    addAttributes() {
        return {
            src: { default: null },
            class: { default: `${VIDEO_CLASS} ${VIDEO_CLASS}_full` },
            width: {
                default: 100,
                parseHTML: (element) =>
                    parseInt((element as HTMLElement).style.width, 10) || 100,
                renderHTML: (attributes) =>
                    String(attributes.class ?? '').includes(VIDEO_PAGE_CLASS)
                        ? {}
                        : { style: `width:${attributes.width}%` },
            },
        };
    },

    parseHTML() {
        return [{ tag: 'iframe[src]' }];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            'iframe',
            mergeAttributes(HTMLAttributes, {
                frameborder: '0',
                allowfullscreen: 'true',
            }),
        ];
    },
});
